import MyCollapse from "../../components/MyCollapse";

const KCDH03 = () => {
  const content = [
    {
      value: 1,
      title: "연구 참여 대상",
      content: () => (
        <div className="collapse-content">
          <div className="ac_text cdh4-1">
            <dl>
              <dt>01</dt>
              <dd>
                <h3>선정 기준</h3>

                <p>1) 산전 또는 산후 CDH로 진단</p>
                <p>
                  2) 연구 참여병원 출생 후 NICU 입원(inborn) 또는 외부 병원 출생
                  후 생후 30일 이내 연구 참여병원 NICU 입원 (outborn)
                </p>
              </dd>
            </dl>
            <dl>
              <dt>02</dt>
              <dd>
                <h3>제외 기준</h3>

                <p>1) 출생 후 NICU 입원 전 분만장/수술장 사망</p>
                <p>
                  2) 연구 참여병원 출생 후 생후 7일 이내 연구 미참여 병원으로
                  전원
                </p>
                <p>
                  3) 산전 CDH 진단이 출생 후 변경된 경우 (예, eventration 등)
                </p>
                <p>
                  4) 기타 연구자에 의해 연구 참여가 불가능하다고 판단된 경우
                </p>
              </dd>
            </dl>
          </div>
        </div>
      ),
    },
    {
      value: 2,
      title: "연구 지표 안내",
      content: () => (
        <div className="collapse-content">
          <div className="ac_text cdh4-2">
            <dl>
              <dt>01</dt>
              <dd>
                <h3>임상 지표 수집</h3>
                <p>산전, 입원기간, 외래 추적 기간의 임상 지표 수집</p>
                <div className="box_wrap">
                  <div className="box">
                    <img src="/assets/img/cd4-1.png" alt="" />
                    <ul>
                      <li>
                        <h4>산전 진단</h4>
                      </li>
                      <li>
                        <span>•</span>
                        <p>
                          <b>폐형성부전지표</b>
                        </p>
                      </li>
                      <li>
                        <span>•</span>
                        <p>
                          <b>태아성장</b>
                        </p>
                      </li>
                      <li>
                        <span>•</span>
                        <p>
                          <b>기타 기형</b>
                        </p>
                      </li>
                    </ul>
                  </div>
                  <span className="arrow">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="27"
                      height="30"
                      viewBox="0 0 27 30"
                      fill="none"
                    >
                      <path
                        d="M26 13.2679C27.3333 14.0377 27.3333 15.9622 26 16.732L3.5 29.7224C2.16667 30.4922 0.499999 29.53 0.499999 27.9904L0.5 2.00962C0.5 0.470019 2.16667 -0.492234 3.5 0.277567L26 13.2679Z"
                        fill="#F1F1F5"
                      />
                    </svg>
                  </span>
                  <div className="box">
                    <img src="/assets/img/cd4-2.png" alt="" />
                    <ul>
                      <li>
                        <h4>신생아 집중치료</h4>
                      </li>
                      <li>
                        <span>•</span>
                        <p>
                          <b>내과 치료</b>
                          <br />
                          소생술, 인공 환기, 폐동맥고혈압치료, ECMO
                        </p>
                      </li>
                      <li>
                        <span>•</span>
                        <p>
                          <b>외과 교정술</b>
                          <br />
                          수술시기, 수술기법
                        </p>
                      </li>
                    </ul>
                  </div>
                  <span className="arrow">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="27"
                      height="30"
                      viewBox="0 0 27 30"
                      fill="none"
                    >
                      <path
                        d="M26 13.2679C27.3333 14.0377 27.3333 15.9622 26 16.732L3.5 29.7224C2.16667 30.4922 0.499999 29.53 0.499999 27.9904L0.5 2.00962C0.5 0.470019 2.16667 -0.492234 3.5 0.277567L26 13.2679Z"
                        fill="#F1F1F5"
                      />
                    </svg>
                  </span>
                  <div className="box">
                    <img src="/assets/img/cd4-3.png" alt="" />
                    <ul>
                      <li>
                        <h4>외래 추적</h4>
                      </li>
                      <li>
                        <span>•</span>
                        <p>
                          <b>성장과 발달</b>
                        </p>
                      </li>
                      <li>
                        <span>•</span>
                        <p>
                          <b>심폐 기능</b>
                        </p>
                      </li>
                      <li>
                        <span>•</span>
                        <p>
                          <b>외과적 재발</b>
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
              </dd>
            </dl>
            <dl className="cdh4-3">
              <dt>02</dt>
              <dd>
                <h3>자료수집항목</h3>
              </dd>
            </dl>
            <div className="scroll2 cdh_table cdh_table2">
              <table style={{ width: "100%" }}>
                <tr>
                  <th width="16%">구분</th>
                  <th width="84%">수집자료</th>
                </tr>
                <tr>
                  <th>산전 자료</th>
                  <td>
                    <ul>
                      <li>
                        <span>-</span>
                        <p>
                          산모 역학, 질병 (고혈압, 당뇨, 기타 질환), 산전
                          스테로이드
                        </p>
                      </li>
                      <li>
                        <span>-</span>
                        <p>산전 유전 진단</p>
                      </li>
                      <li>
                        <span>-</span>
                        <p>
                          산전 초음파자료 (진단시기, observed and expected
                          lung-to-head ratio [O/E LHR], 양수상태, 종격동 전위,
                          좌/우/양쪽, liver up/down. 동반기형)
                        </p>
                      </li>
                      <li>
                        <span>-</span>
                        <p>산전 시술(FETO, amniocentesis 등)</p>
                      </li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <th>입원자료</th>
                  <td>
                    <ul>
                      <li>
                        <span>-</span>
                        <p>
                          기본정보 <br />
                          연구의학자료 (성별, 임신나이, 체중, 신장, 두위, 흉위,
                          복위), 분만방법, 1분/5분 아프가 점수, 제대관리{" "}
                        </p>
                      </li>
                      <li>
                        <span>-</span>
                        <p>
                          진단 정보 <br />
                          동반 기형 리스트 (유전정보, 장기 계통별 진단: ICD-10
                          이용), 폐동맥고혈압/좌심기능지표 (심초음파 항목 명시)
                        </p>
                      </li>
                      <li>
                        <span>-</span>
                        <p>
                          내과 치료방법 <br />
                          소생술 과정 (제대결찰, 심폐소생술 단계), 폐표면활성제
                          투여, ICU 포괄 정보 (NICU 입원 기간 중 daily data):
                          활력 징후, input/output, 인공환기(설정, 흡입산소농도,
                          평균기도압 등), 승압제 정보 (vasoactive score), 약물
                          치료 등 (약 1500개의 데이터 입력){" "}
                        </p>
                      </li>
                      <li>
                        <span>-</span>
                        <p>
                          외과 치료 정보 <br />
                          수술시기, 수술방법 (open/minimal invasive), patch
                          repair 유무와 재질, 수술 소견 (defect grade, 간 위치),
                          급성 외과적 합병증과 처치
                        </p>
                      </li>
                      <li>
                        <span>-</span>
                        <p>
                          ECMO 자료 (있는 경우) <br />
                          회차, 각 회차 별 시작 일시, mode, 시행 전 혈액가스
                          지표
                        </p>
                      </li>
                      <li>
                        <span>-</span>
                        <p>
                          결과 변수 <br />
                          생존 또는 전원, 사망 (일시), 생후 30일/퇴원 시 호흡
                          보조 상태, 뇌영상 검사, 수유 도달 시간, 퇴원 시 수유
                          방법, 위식도 역류, 청력 스크리닝, 퇴원시 약물 또는
                          장비
                        </p>
                      </li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <th>외래추적</th>
                  <td>
                    <ul>
                      <li>
                        <span>-</span>
                        <p>
                          성장지표 <br />
                          체중/신장/두위/흉위 (1세, 2세), 흉곽이상, 척추측만증
                        </p>
                      </li>
                      <li>
                        <span>-</span>
                        <p>
                          발달지표 <br />
                          Bayley 영유아 발달검사 (ver II or III: 1세, 2세),
                          한국형 영유아 발달 선별검사 (K-DST,
                          대근육/소근육/인지/사회성/자조/추가질문),
                          M-CHART(자폐성향지표)
                        </p>
                      </li>
                      <li>
                        <span>-</span>
                        <p>
                          외과적 예후 <br />
                          재발 유무 (재발 시기, 1차, 2차 등), 위식도역류 진단과
                          치료 (약물, fundoplication)
                        </p>
                      </li>
                      <li>
                        <span>-</span>
                        <p>
                          기타 합병증 <br />
                          심초음파 (6개월 - 12개월), 청력정밀검사 (6개월 -
                          12개월)
                        </p>
                      </li>
                    </ul>
                  </td>
                </tr>
              </table>
            </div>
            <dl className="cdh4-3">
              <dt>03</dt>
              <dd>
                <h3>외래추적 정보</h3>
              </dd>
            </dl>
            <div className="scroll cdh_table">
              <table style={{ width: "100%" }}>
                <tr>
                  <th width="16%">Verison1.5</th>
                  <th width="14%">Visit1</th>
                  <th width="14%">Visit2</th>
                  <th width="14%">Visit3</th>
                  <th width="14%">Visit4</th>
                  <th width="14%">Visit5</th>
                  <th width="14%">Visit6</th>
                </tr>
                <tr>
                  <th>FU months (mo)</th>
                  <td>
                    <b>2</b>
                  </td>
                  <td>
                    <b>6</b>
                  </td>
                  <td>
                    <b>12</b>
                  </td>
                  <td>
                    <b>24</b>
                  </td>
                  <td>
                    <b>36</b>
                  </td>
                  <td>
                    <b>60</b>
                  </td>
                </tr>
                <tr>
                  <th>Data window (mo)</th>
                  <td>0-2</td>
                  <td>3-6</td>
                  <td>7-12</td>
                  <td>13-24</td>
                  <td>25-36</td>
                  <td>37-60</td>
                </tr>
                <tr>
                  <th>Visit</th>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr>
                <tr>
                  <th>자료수집</th>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr>
                <tr>
                  <th>생존/사망</th>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr>
                <tr>
                  <th>성장지표</th>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr>
                <tr>
                  <th>재발/재수술</th>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr>
                <tr>
                  <th>관리/치료 항목</th>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr>
                <tr>
                  <th>재입원</th>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr>
                <tr>
                  <th>골격이상</th>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr>
                <tr>
                  <th>폐동맥고혈압</th>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr>
                <tr>
                  <th>청력검사</th>
                  <td>-</td>
                  <td>0</td>
                  <td>(0)</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                <tr>
                  <th>뇌성마비</th>
                  <td>-</td>
                  <td>-</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>-</td>
                </tr>
                <tr>
                  <th>K-DST</th>
                  <td>-</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>-</td>
                </tr>
                <tr>
                  <th>베일리발달평가</th>
                  <td>-</td>
                  <td>-</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>-</td>
                </tr>
                <tr>
                  <th>M-CHAT-R</th>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>0</td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                <tr>
                  <th>PFT</th>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>0</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="acco cdh">
      <MyCollapse data={content} />
    </div>
  );
};

export default KCDH03;
